module.exports = __webpack_public_path__ + "img/nye-2023.27a0f68a.webp";